//@flow
import React from 'react';
import {Typography, makeStyles} from '@material-ui/core';

import CustomModal from '../../../../elements/CustomModal/CustomModal';

import type {Theme} from '@material-ui/core';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import {Description} from '@material-ui/icons';
import CustomButton from '../../../../elements/CustomButton/CustomButton';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '380px',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  body: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  saleChannelTextfield: {
    width: '100%',
  },
  relatedDocument: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    padding: '.75rem',
    borderRadius: '.5rem',
    background: '#F5F5F5',
  },
  relatedDocumentText: {
    fontSize: '.875rem',
  },
  footer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
  },
  button: {
    width: '100%',
  },
}));

type Props = {
  open: boolean,
  onClose: () => void,
};

export default function CreateCreditNote(props: Props) {
  const {open, onClose} = props;

  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={onClose}>
      <aside className={classes.root}>
        <header className={classes.header}>
          <Typography className={classes.title}>Nota de crédito</Typography>
        </header>

        <div className={classes.body}>
          <CustomTextField label="Monto" />

          <CustomTextField
            className={classes.saleChannelTextfield}
            label="Comentario"
            multiline
            rows={3}
            name="newComment"
          />

          <div className={classes.relatedDocument}>
            <Description />
            <Typography className={classes.relatedDocumentText}>
              Documento Asociado
            </Typography>
          </div>
        </div>
      </aside>

      <footer className={classes.footer}>
        <CustomButton className={classes.button} variant="contained" fullWidth>
          Enviar
        </CustomButton>
      </footer>
    </CustomModal>
  );
}
